import React, { useState, useCallback, useMemo } from 'react';
import classNames from 'classnames';

import CheckCircleIcon from 'components/Icon/CheckCircle';
import TextField from 'components/TextField';

const position = { right: 17 };

export default function List(props) {
  const { className, anchor, expanded, options, valueField, labelField, onChangeSelection, selections, multiselect, name, setExpanded, showSearch, renderOption } = props;
  const [filter, setFilter] = useState('');
  const onFilterChange = useCallback((event) => setFilter(event.target.value), []);
  const filteredOptions = useMemo(() => {
    if (filter) {
      const regexp = new RegExp(filter, 'i');
      return options.filter((item) => regexp.test(item[labelField]));
    }

    return options || [];
  }, [filter, labelField, options]);

  return (
    <div
      className={classNames('Dropdown_list fixed inset-0 bg-neutral-darker overflow-auto shadow-lg z-10 md:absolute md:border-t-2 md:border-neutral md:rounded', className, {
        'md:right-auto md:bottom-auto': anchor === 'bottom-left',
        'md:left-auto md:top-auto md:bottom-auto': anchor === 'bottom-right',
        'md:top-auto md:left-auto': anchor === 'top-right',
        'md:top-auto md:bottom-auto': anchor === 'full',
        'md:w-64': anchor !== 'full',
      })}
      style={{ display: expanded ? 'block' : 'none' }}
    >
      <div className="bg-dropdown min-h-full">
        {showSearch &&
          <div className="Dropdown_list_search p-2">
            <TextField placeholder="Search items..." onChange={onFilterChange} value={filter} />
          </div>
        }
        {
          filteredOptions.map((item) => {
            const selected = selections && selections.findIndex(sel => sel[valueField] === item[valueField]) >= 0;
            const label = item[labelField];
            const value = item[valueField];

            return (
              <button
                key={value}
                title={label}
                className={classNames('relative px-6 py-3 block w-full rounded-none text-left font-sans text-sm truncate focus:outline-none hover:bg-primary hover:text-default', {
                  'text-secondary': !selected,
                  'text-default pr-12': selected,
                })}
                onClick={(event) => {
                  event.preventDefault();

                  if (onChangeSelection) {
                    if (multiselect) {
                      const newSelections = selected
                        ? selections.filter(sel => sel[valueField] !== item[valueField])
                        : [...selections, item];

                      onChangeSelection(name, newSelections);
                    } else {
                      onChangeSelection(name, item)
                    }
                  }

                  if (!multiselect) {
                    setExpanded(false);
                  }
                }}
              >
                {renderOption && renderOption(item, selected)}
                {!renderOption && label}
                {selected &&
                  <span className="text-primary absolute" style={position}>
                    <CheckCircleIcon width={20} height={20} className="inline float-right" />
                  </span>
                }
              </button>
            );
          })
        }
      </div>
    </div>
  );
}
